<template>
  
    <div class="bg-white rounded-lg h-full">

        <div class="sticky top-0 bg-white z-50 ">

            <div class="myCenter">

                <button 
                    class="classPageFontAwesomeButton"
                    v-on:click="closeMembershipPage">
                            
                    <font-awesome-icon icon="times-circle" size="2x"/> 
                </button>
            </div>

            <div class="">
                
                <my-page-tabs :itemIsSelected="itemIsSelected" :showInstructorTab="false"
                :tabOneName="tabOneName" :tabTwoName="tabTwoName" :tabThreeName="tabThreeName"/>
            </div>
        </div>

        <div>

            <div v-if="tab == 1" class="">

                <studios-membership-details-page :myMembership="myMembership" :refreshPageReady="refreshPageReady"/>
            </div>

            <div v-if="tab == 2">

                <class-business :businessId="myMembership.business.id"/>
            </div>


            <div v-if="tab == 3">

                <class-instructor :instructorId="myMembership.class.instructor.id" 
                :isFromPage="true"/>
            </div>
        </div>
    </div>

</template>

<script>

import myPageTabs from '../../components-v2/controls/MyPageTabs.vue';

import studiosMembershipDetailsPage from './StudioMembershipDetailsPage.vue';

import ClassBusiness from '../commonComponents/BusinessPage.vue';

import ClassInstructor from '../commonComponents/InstructorPage.vue'

export default {

    mounted(){

    },

    props:{
        
        setMainRefreshPageReady: {

            type: Function 

        },

         closeMembershipPage: {

            type: Function 
        },

        myMembership:{
        
            type: Object,
            default: () => ({})
        },

    },

    components:{

        myPageTabs,
        studiosMembershipDetailsPage,
        ClassBusiness,
        ClassInstructor               
    },

    methods:{

        itemIsSelected(value){

            this.tab = value;
        },

        refreshPageReady(refreshPage){


            this.setMainRefreshPageReady(refreshPage);  
            
        },

        callCloseMembershipPage(){

            this.closeMembershipPage(this.refreshPage);
        }

    },

    data: function(){

        return {

            tab: 0,
            tabOneName: "studio",
            tabTwoName: "business",
            tabThreeName: "instructor",
            refreshPage: false
        }
    }
}
</script>

<style>

</style>